var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1H1.50667M1.5 7H1.50667M1.5 13H1.50667M1.5 10H1.50667M1.5 4H1.50667M4.5 1H4.50667M4.5 7H4.50667M4.5 13H4.50667M10.5 1H10.5067M10.5 7H10.5067M10.5 13H10.5067M7.5 1H7.50667M7.5 7H7.50667M7.5 13H7.50667M7.5 10H7.50667M7.5 4H7.50667M13.5 1H13.5067M13.5 7H13.5067M13.5 13H13.5067M13.5 10H13.5067M13.5 4H13.5067",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.2bcecef5ca4d6737b2a6cd5f44455c25.svg";
export { ForwardRef as ReactComponent };